import {Box} from '~/CreateFabricInvitation/components/Box/Box';
import {EditorGroup} from '~/CreateFabricInvitation/components/EditorGroup/EditorGroup';
import {EditorHeader} from '~/CreateFabricInvitation/components/EditorHeader/EditorHeader';
import {EditorResetHeader} from '~/CreateFabricInvitation/components/EditorHeader/EditorResetHeader';
import {useBackground} from '~/common/FabricInvitation/EventCreateDesign/components/Background/actions/useBackground';
import {EditBox} from '~/common/FabricInvitation/EventCreateDesign/components/EditBox/EditBox';
import {EditorIcons} from '~/common/FabricInvitation/EventCreateDesign/components/EditorIcons/EditorIcons';
import {useOverlay} from '~/common/OverlayAnimation/actions/useOverlay';
import {Button} from '~library/atoms/Button';
import {Typography} from '~library/atoms/Typography';
import {SparkleIcon} from '~library/svg/SparkleIcon';
import {BackgroundColorPicker} from '../CardEditor/actions/ColorPicker/BackgroundColorPicker';

import './BackgroundEditor.sass';

export const BackgroundEditor = () => {
  const {
    backgroundIcons,
    onColorChange,
    onTextureChange,
    onBackgroundReset,
    selectedBackground,
    hasBackgroundChanged,
  } = useBackground();
  const {onOverlayChange, onOverlayReset, overlayIcons, selectedOverlay, hasOverlayChanged} =
    useOverlay(false, false);

  return (
    <div className="background-editor">
      <EditBox>
        <EditorGroup>
          <EditorHeader
            title="Background Textures"
            extra2={
              <div className="background-editor__header__right">
                <SparkleIcon ratio={0.75} className="background-editor__svg" />
                <Typography variant="label2" color="tanzanite">
                  Animated
                </Typography>
              </div>
            }
            extra={
              <Button
                variant="link"
                size="small"
                className="reset_all__button"
                onClick={onBackgroundReset}
                disabled={!hasBackgroundChanged}
              >
                Reset
              </Button>
            }
          />
          <Box className="background-editor__box" height="17rem">
            <BackgroundColorPicker onColorChange={onColorChange} />
            <EditorIcons
              icons={[{component: <BackgroundColorPicker onColorChange={onColorChange} />}].concat(
                backgroundIcons
              )}
              selectedIcon={selectedBackground?.icon}
              onClick={onTextureChange}
              height={50}
              width={50}
              className="editor-icons__background"
            />
          </Box>
        </EditorGroup>
        <EditorGroup>
          <EditorResetHeader
            title="Background Effects"
            onReset={onOverlayReset}
            dataQaId="step1-background-effects-reset"
            enabled={hasOverlayChanged}
          />
          <Box className="background-editor__box" height="14rem">
            <EditorIcons
              icons={overlayIcons}
              selectedIcon={selectedOverlay}
              onClick={onOverlayChange}
              height={64}
              width={50}
              hideAnimatedIndicator
              outline
            />
          </Box>
        </EditorGroup>
      </EditBox>
    </div>
  );
};
